export const googleAdsConversion = (id: string) => {
  (window as any)?.gtag('event', 'conversion', {
    send_to: `${process.env.NEXT_PUBLIC_GOOGLE_ADS_ID}/${process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_KEY}`,
    transaction_id: id
  });
};
